<script lang="ts">
  import {tempId} from "../../../store"
  import SocialTimeLine from "./SocialTimeLine.svelte";
  import SocialAbout from "./SocialAbout.svelte";
  import SocialFriends from "./SocialFriends.svelte";
  import SocialPhotos from "./SocialPhotos.svelte";
    let setTempid:string
    tempId.subscribe((value)=>{
        setTempid = value
    })
</script>
<div class="tab-content" id="top-tabContent">
    <SocialTimeLine />
    <SocialAbout />
    <SocialFriends />
    <SocialPhotos />
</div>